import { useQuery } from 'react-query';
import axios from 'axios';
import { ContactInfoDto } from '../models/contactInfo';

const getContacts = async (): Promise<ContactInfoDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}contacts/Index`);
  return data;
};

const useContacts = () => useQuery('contacts', getContacts);

export default useContacts;
